import React, { useReducer } from 'react';
import { View, ScrollView, StyleSheet, SafeAreaView } from 'react-native';
import { Screens } from '../../constants/ScreenNames';
import Button, { BUTTON_TYPES } from '../Button';
import { selectCarFilterByDetails } from '../../store/selectors/car.selector';
import { useSelector, useDispatch } from 'react-redux';
import OptionNavigate from '../OptionNavigate';
import { CommonProperties, CommonStyles } from '../../styles';
import Images from '../../constants/Images';
import { formatCurrency } from '../../utils/currency.utils';
import { filterByDetails } from '../../store/actions/car';
import RowView from '../RowView';
import BaseText from '../BaseText';
import BottomButton from '../BottomButton';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import useTextCarFilter from '../../utils/useTextCarFilter';
import produce from 'immer';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../../store/selectors/auth.selector';

const CHECK = 'CHECK';
const CHECK_ALL = 'CHECK_ALL';

const reducer = (state, action) => {
  switch (action.type) {
    case CHECK:
      return produce(state, (draft) => {
        draft[action.group][action.vendor].checked = !state[action.group][action.vendor].checked;
      });
    case CHECK_ALL:
      return produce(state, (draft) => {
        Object.keys(draft[action.group]).forEach((key) => {
          draft[action.group][key].checked = !action.selected;
        });
      });
    default:
      return state;
  }
};

const areFiltersValid = (filters) => {
  if (!filters) {
    return false;
  }

  return Object.values(filters).every((group) =>
    Object.values(group).some((filter) => filter.checked)
  );
};

const CarFilterModal = ({ navigation }) => {
  const { tKey } = useComponentTKey('CarFilterModal');
  const { t } = useTranslation(i18nNS.car);
  const dispatch = useDispatch();
  const carfilters = useSelector(selectCarFilterByDetails);
  const [filters, dispatchFilters] = useReducer(reducer, carfilters);
  const filtersValid = areFiltersValid(filters);
  const [filtersMap] = useTextCarFilter();
  const currency = useSelector(selectCompanyCurrency);
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);
  return (
    <SafeAreaView style={CommonStyles.flex1}>
      <ScrollView style={[CommonStyles.flex1, CommonStyles.py3]}>
        {Object.entries(filters).map(([group, groupContent]) => {
          const allSelected = !Object.values(groupContent).some((val) => !val.checked);
          return (
            <View key={group} style={CommonStyles.mb5}>
              <RowView style={styles.titleFilter}>
                <BaseText style={CommonStyles.h3}>{filtersMap[group].name}</BaseText>
                <Button
                  style={styles.check}
                  type={BUTTON_TYPES.TEXT}
                  label={allSelected ? t(tKey('ClearAll')) : t(tKey('CheckAll'))}
                  onPress={() => dispatchFilters({ type: CHECK_ALL, group, selected: allSelected })}
                />
              </RowView>
              <BaseText style={styles.title}>{filtersMap[group + 'Group'].name}</BaseText>
              <View style={styles.items}>
                {Object.entries(groupContent).map(([vendor, vendorContent]) => (
                  <OptionNavigate
                    key={vendor}
                    onPress={() => dispatchFilters({ type: CHECK, group, vendor })}
                    title={vendorContent.name}
                    image={Images.car['50x20'][vendor] ? Images.car['50x20'][vendor] : null}
                    price={vendorContent.price}
                    selected={vendorContent.checked}
                  />
                ))}
              </View>
            </View>
          );
        })}
      </ScrollView>
      <BottomButton
        onPress={() => {
          dispatch(filterByDetails(filters));
          navigation.navigate(Screens.Car);
        }}
        label={t(tKey('Apply'))}
        disabled={!filtersValid}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  title: {
    ...CommonProperties.h3,
    ...CommonProperties.my2,
    ...CommonProperties.mx3,
  },
  titleFilter: {
    backgroundColor: 'white',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...CommonProperties.px3,
  },
  items: {
    flex: 1,
    backgroundColor: 'white',
  },
  check: {
    maxWidth: 120,
    alignItems: 'flex-end',
    ...CommonProperties.px0,
  },
});

export default CarFilterModal;
